import Vue from 'vue'
import { find, findIndex, filter, shuffle, sortBy } from 'lodash'

import {
    setFieldValue,
    setFieldError,
    resetFieldError,
    resetFields,
    setNotification,
    resetNotification,
    setFormValid,
    setFormError,
    resetFormError,
    addFieldRule,
    addField,
    removeField
} from './forms/mutations'

const setCurrentPuzzle = (state, { puzzle }) => {
    state.currentPuzzle = puzzle
}

// Used in admin
const setPuzzleWord = (state, { word, index }) => {
    const words = state.currentPuzzle.words

    if (index >= 0) {
        Vue.set(words, index, word)
    } else {
        words.push(word)
    }
}

const setIsSelectingAnswer = (state, { isSelectingAnswer }) => {
    state.gridSettings.isSelectingAnswer = isSelectingAnswer
}

const setCurrentSelectedCell = (state, { cell }) => {
    state.gridSettings.currentSelectedCell = cell
}

const addSelectedCell = (state, { row, column }) => {
    state.gridSettings.selectedCells.push({ row, column })
}

const removeSelectedCell = (state, { row, column }) => {
    state.gridSettings.selectedCells = filter(state.gridSettings.selectedCells, (item) => {
        return item.row !== row && item.column !== column
    })
}

const toggleSelectedCell = (state, { cell }) => {
    const index = findIndex(state.gridSettings.selectedCells, (item) => {
        return item.id === cell.id
    })

    if (index === -1) {
        state.gridSettings.selectedCells.push(cell)
        return
    }

    state.gridSettings.selectedCells.splice(index + 1, state.gridSettings.selectedCells.length)
}

const resetSelectedCells = (state) => {
    state.gridSettings.selectedCells = []
    state.gridSettings.currentSelectedCell = null
}

const shuffleBonusCells = (state) => {
    const bonusItem = find(state.currentPuzzle.words, item => item.is_bonus)
    const bonusWord = bonusItem.word.toLowerCase()

    if (!bonusWord.length) {
        return
    }

    let bonusWordScrambled = bonusWord

    while(bonusWord === bonusWordScrambled) {
        bonusWordScrambled = shuffle(bonusWord).join('')
    }

    const cellsSorted = sortBy(bonusItem.cells, ['row', 'column'])
    bonusItem.cells = cellsSorted.map((item, index) => {
        item.char = bonusWordScrambled[index]
        return item
    })
}

const setActiveWordIndex = (state, { activeWordIndex }) => {
    state.activeWordIndex = activeWordIndex
}

const resetFoundWordIds = (state) => {
    state.foundWordIds = []

    const puzzleId = state.currentPuzzle.id
    if (!puzzleId) {
        return
    }

    localStorage.setItem(`puzzle_found_word_ids_${puzzleId}`, JSON.stringify(state.foundWordIds))
}

const addFoundWordId = (state, { word_id }) => {
    state.foundWordIds.push(word_id)

    const puzzleId = state.currentPuzzle.id
    if (!puzzleId) {
        return
    }

    localStorage.setItem(`puzzle_found_word_ids_${puzzleId}`, JSON.stringify(state.foundWordIds))
}

const setFoundWordIdsFromLocalStorage = (state, { puzzle }) => {
    const puzzleId = puzzle.id
    if (!puzzleId) {
        return
    }

    const localeStorageAnswersJson = localStorage.getItem(`puzzle_found_word_ids_${puzzleId}`)
    if (!localeStorageAnswersJson) {
        return
    }

    state.foundWordIds = JSON.parse(localeStorageAnswersJson)
}

const setFoundWordIdToAnimate = (state, { word_id }) => {
    state.foundWordIdToAnimate = word_id
}

const increaseTimer = (state, { timerId }) => {
    let secondsElapsed = state.timers[timerId] ?? 0
    secondsElapsed++
    Vue.set(state.timers, timerId, secondsElapsed)
    localStorage.setItem(`timer_${timerId}`, secondsElapsed)
}

const setTimerFromLocalStorage = (state, { timerId }) => {
    let secondsElapsed = localStorage.getItem(`timer_${timerId}`)

    if (!secondsElapsed) {
        secondsElapsed = 0
    }

    Vue.set(state.timers, timerId, secondsElapsed)
}

const resetTimer = (state, { timerId }) => {
    const secondsElapsed = 0
    Vue.set(state.timers, timerId, secondsElapsed)
    localStorage.setItem(`timer_${timerId}`, secondsElapsed)
}

/*
 *  POPUP
 */
const togglePopup = (state, { type }) => {
    state.showPopup = (type && type === state.popupType) || !type ? !state.showPopup : true
    state.popupType = type
}

const resetPopup = (state) => {
    state.showPopup = false
}

const setTexts = (state, { texts }) => {
    state.texts = texts
}

// Export
export default {
    setCurrentPuzzle,
    setPuzzleWord,

    // Cell selection
    setIsSelectingAnswer,
    setCurrentSelectedCell,
    addSelectedCell,
    removeSelectedCell,
    toggleSelectedCell,
    resetSelectedCells,
    shuffleBonusCells,

    // Marking words as 'found'
    addFoundWordId,
    resetFoundWordIds,
    setFoundWordIdsFromLocalStorage,
    setFoundWordIdToAnimate,
    setActiveWordIndex,

    increaseTimer,
    setTimerFromLocalStorage,
    resetTimer,

    togglePopup,
    resetPopup,
    setTexts,

    // forms
    setFieldValue,
    setFieldError,
    resetFieldError,
    resetFields,
    setNotification,
    resetNotification,
    setFormValid,
    setFormError,
    resetFormError,
    addFieldRule,
    addField,
    removeField
}
